module.exports = __webpack_public_path__ + "img/icon-one.e59ffe66.svg";